import { Injectable } from '@angular/core';
import {
  Critter,
  UpdateStudentAvatarDTO,
} from '@app/infrastructure/models/critter';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { UserStateService } from '../state/user-state.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class StudentCritterService {
  constructor(
    private apiService: ApiService,
    private userState: UserStateService,
  ) {}

  public getStudentCritters(): Observable<Critter[]> {
    const user = this.userState.userSession;
    const url = `${environment.apiRoute}/students/${user.student.id}/critters`;
    return this.apiService.get<Critter[]>(url);
  }

  public addCritterToCollection(): Observable<Critter> {
    const user = this.userState.userSession;
    const url = `${environment.apiRoute}/students/${user.student.id}/critters`;
    return this.apiService.post<Critter, void>(url, null);
  }

  public updateStudentCritter(
    critterId: number,
    dto: UpdateStudentAvatarDTO = new UpdateStudentAvatarDTO(),
  ): Observable<Critter> {
    const user = this.userState.userSession;
    const url = `${environment.apiRoute}/students/${user.student.id}/critters/${critterId}`;
    return this.apiService.patch<Critter, UpdateStudentAvatarDTO>(url, dto);
  }
}
